<!-- Left Side -->
<!-- <div class="w-12 lg:w-7 border-right-1 border-300" [ngClass]="isCurrentTenantClient ? 'bg-yellow-100' : 'surface-0'"> -->
    <div class="overflow-y-auto lg:h-screen">

        <div class="pb-3 md:pb-0">
            <div
                class="px-2 py-2 flex align-items-center justify-content-between sticky top-0 left-0 w-full" [ngClass]="isCurrentTenantClient ? 'surface-0' : 'bg-yellow-100'">
                <div (click)="closeSidebar()" *ngIf="showCloseIcon$ | async"
                    class="flex align-items-center justify-content-center w-2rem h-2rem surface-100 cursor-pointer">
                    <i class="text-600 fa fa-times text-xl"></i>
                </div>

                <div *ngIf="!showSkeleton" class="flex align-items-center justify-content-end">

                    <p-button *ngIf="selectedClientInfo" 
                              icon="fa fa-angle-down text-sm" 
                              iconPos="right" 
                              [label]="selectedClientInfo.name + ' - ' + selectedClientInfo.value" 
                              styleClass="text-xs p-button-outlined py-2 text-600 border-600 surface-0 mr-2" 
                              (click)="profileAction.toggle($event)"
                              [attr.aria-label]="'client-info-dropdown'"
                              [attr.data-testid]="'client-info-dropdown'"></p-button>
                    <p-popover #profileAction 
                               styleClass="surface-0 shadow-3 border-1 border-300 border-round text-sm w-14rem"
                               [attr.aria-label]="'client-info-popover'"
                               [attr.data-testid]="'client-info-popover'">
                      <ng-template #content>
                        <div class="py-2">
                          <div class="cursor-pointer hover:surface-100 px-3 py-2 transition-colors transition-duration-150" 
                               *ngFor="let clientInfo of clientInfos | async; let i = index" 
                               (click)="copyToClipboard(clientInfo.value)"
                               [attr.aria-label]="'client-info-item-' + clientInfo.name.toLowerCase().replace(' ', '-')"
                               [attr.data-testid]="'client-info-item-' + i">
                             <div class="flex align-items-center justify-content-between">
                               <div class="flex flex-column gap-1">
                                 <span class="text-sm font-medium text-900 line-height-1" 
                                       [attr.data-testid]="'client-info-name-' + i">{{clientInfo.name}}</span>
                                 <span class="text-sm text-700 line-height-1" 
                                       [attr.data-testid]="'client-info-value-' + i">{{clientInfo.value}}</span>
                               </div>
                               <i class="fa fa-copy text-400 hover:text-600 transition-colors transition-duration-150 ml-3" 
                                  [attr.aria-label]="'copy-' + clientInfo.name.toLowerCase().replace(' ', '-')"
                                  [attr.data-testid]="'copy-icon-' + i"></i>
                             </div>
                          </div>
                        </div>
                      </ng-template>
                    </p-popover>
                    <div *ngIf="client.preferred_language" class="flex align-items-center text-xs surface-200 py-1 px-3 border-round"
                        pTooltip="Preferred Language" tooltipStyleClass="text-xs">
                        <img width="15" src="assets/img/flags/{{getFlag(client.preferred_language)}}.svg" />
                        <div class="ml-1">{{ 'common.LANGUAGE.' + client.preferred_language.toUpperCase() | translate}}</div>
                    </div>
                </div>
                <div *ngIf="showSkeleton" class="flex align-items-center justify-content-end">
                    <p-skeleton width="8rem" height="1.3rem" styleClass="mr-3"></p-skeleton>
                    <p-skeleton width="5rem" height="1.3rem"></p-skeleton>
                </div>
            </div>

            <!-- Name and Image -->
            <div class="px-3 flex align-items-center mt-2">
                <div *ngIf="!showSkeleton" class="relative">
                    <p-avatar *ngIf="client.image" [image]="client.image" shape="circle"
                        styleClass="w-4rem h-4rem"></p-avatar>
                    <p-avatar *ngIf="!client.image" [label]="client.full_name | titlecase | shortName" shape="circle"
                        styleClass="w-4rem h-4rem"></p-avatar>
                    <div *ngIf="hasAnyRelation(client) && client.parent_client_id > 0" (mouseenter)="relation_detail.toggle($event)"
                        class="bg-purple-400 text-white border-round-xl px-2 py-1 font-bold absolute right-0 top-0 text-xs -mr-4 -mt-2"
                        aria-label="client-relation-badge">
                        {{client.relation}}
                    </div>
                    <p-popover #relation_detail styleClass="overflow-hidden mt-0" aria-label="relation-details-popover">
                        <ng-template #content>
                            <div class="flex align-items-center text-sm -m-2" *ngFor="let relation of getRelationDetails(client)" aria-label="relation-detail-item">
                                <p-avatar [image]="relation.relationImage" shape="circle" aria-label="relation-avatar"></p-avatar>
                                <div class="ml-1">
                                    <div class="font-bold mb-1" aria-label="relation-name">{{relation.relationName}}</div>
                                    <div class="text-xxs" aria-label="relation-type">Relation: {{relation.relationType}}</div>
                                </div>
                            </div>
                        </ng-template>
                    </p-popover>
                </div>
                <p-skeleton *ngIf="showSkeleton" width="4rem" height="4rem" shape="circle"></p-skeleton>
                <div  [ngClass]="hasAnyRelation(client) && client.parent_client_id > 0 ? 'ml-4' : 'ml-2'">
                    <div *ngIf="!showSkeleton" class="font-bold flex align-items-center mb-2">
                        <span>{{client.full_name}}</span>
                        <i [class]="'fa fa-crown {{crownType(client.client_since).color}} ml-2'"></i>
                        <i *ngIf="client.is_digital_keyfob" [class]="'fa fa-key ml-2 text-green-500'"></i>
                    </div>
                    <p-skeleton *ngIf="showSkeleton" width="5rem" height="1.1rem" styleClass="mb-2"></p-skeleton>

                    <!-- Badge -->
                    <div *ngIf="!showSkeleton" class="flex align-items-center">
                        <span *ngIf="client.track_mode && client.track_mode.toLowerCase() === 'clientwebsignup'"
                            class="bg-green-50 px-2 py-1 border-round text-green-400 text-xxs uppercase">
                            {{ 'CLIENT_PROFILE.WEBSITE_LEAD' | translate }}
                        </span>
                        <div [innerHTML]="clientStatus(client)" class="mr-1"></div>
                        <span *ngIf="client.stage_master"
                            class="text-bluegray-500 px-2 py-1 border-round border-1 border-bluegray-500 text-xxs ml-1 uppercase">
                            {{ getStageStatus() | async}}
                        </span>
                    </div>
                    <div *ngIf="showSkeleton" class="flex align-items-center">
                        <p-skeleton height="1.25rem" styleClass="w-4rem"></p-skeleton>
                        <p-skeleton height="1.25rem" styleClass="w-4rem ml-1"></p-skeleton>
                        <p-skeleton height="1.25rem" styleClass="w-4rem ml-1"></p-skeleton>
                    </div>
                </div>
            </div>
            <!-- Badge -->

            <!-- Info Icons -->
            <div *ngIf="!showSkeleton" class="px-3 flex justify-content-center text-700 mt-2 relative z-1">
                <div class="text-center" pTooltip="{{ 'CLIENT_PROFILE.MAKE_CALL' | translate }}"
                    tooltipStyleClass="text-xs" tooltipPosition="bottom">
                    <div
                        class="w-3rem h-2rem border-1 border-300 border-round mx-auto flex align-items-center justify-content-center cursor-pointer text-gray-900 bg-white">
                        <a class="text-gray-900" href="tel:{{ client.mobile_country_code + client.mobile_number }}">
                            <i class="fa fa-phone"></i>
                        </a>
                    </div>
                </div>
                <div class="ml-1" pTooltip="{{ 'CLIENT_PROFILE.SEND-SMS' | translate }}"
                    tooltipStyleClass="text-xs" tooltipPosition="bottom">
                    <div class="w-3rem h-2rem border-1 border-300 border-round mx-auto flex align-items-center justify-content-center cursor-pointer text-gray-900 bg-white"
                        (click)="toggleCreateSmsDialog()">
                        <i class="fa fa-comment-sms"></i>
                    </div>
                </div>
                <div class="ml-1" pTooltip="{{ 'CLIENT_PROFILE.SEND-WHATS-APP' | translate }}"
                    tooltipStyleClass="text-xs" tooltipPosition="bottom">
                    <!-- <div class="w-3rem h-2rem border-1 border-300 border-round mx-auto flex align-items-center justify-content-center cursor-pointer text-gray-900 bg-white"
                        (click)="toggleSendWhatsAppDialog()">
                        <i class="fab fa-whatsapp"></i>
                    </div> -->
                    <div (click)="whatsappDropdown.toggle($event)" class="w-3rem h-2rem border-1 border-300 border-round mx-auto flex align-items-center justify-content-center cursor-pointer text-gray-900 bg-white">
                        <i class="fab fa-whatsapp"></i>
                    </div>
                    <p-popover #whatsappDropdown styleClass="overflow-hidden right-0 text-sm w-13rem -ml-5">
                      <ng-template #content>
                        <ul class="list-none -m-4 py-2 px-0 text-xs text-600">
                            <li class="cursor-pointer hover:surface-300 py-2 px-3"><a class="text-600" href="https://api.whatsapp.com/send?phone={{ client.mobile_country_code+client.mobile_number }}&text=Hello" target="_blank">{{ 'CLIENT_PROFILE.SEND_WHATSAPP_CHAT' | translate }}</a></li>
                            <li class="cursor-pointer hover:surface-300 py-2 px-3" (click)="toggleSendWhatsAppDialog()">{{ 'CLIENT_PROFILE.SEND_WHATSAPP_TEMPLATE' | translate }}</li>
                        </ul>
                      </ng-template>
                    </p-popover>
                </div>
                <div class="ml-1" pTooltip="{{ 'CLIENT_PROFILE.SEND-EMAIL' | translate }}"
                    tooltipStyleClass="text-xs" tooltipPosition="bottom">
                    <div class="w-3rem h-2rem border-1 border-300 border-round mx-auto flex align-items-center justify-content-center cursor-pointer text-gray-900 bg-white"
                        (click)="toggleSendEmailDialog()">
                        <i class="fa fa-envelope"></i>
                    </div>
                </div>
                <div class="ml-1" pTooltip="{{ 'CLIENT_PROFILE.BOOK_TOOLTIP' | translate }}"
                    tooltipStyleClass="text-xs" tooltipPosition="bottom">
                    <div class="w-3rem h-2rem border-1 border-300 border-round mx-auto flex align-items-center justify-content-center cursor-pointer text-gray-900 bg-white"
                        (click)="showBookAppointmentPopup=true">
                        <i class="fa fa-calendar-plus"></i>
                    </div>
                </div>
                <div class="ml-2 text-center relative">
                    <prospect-list-actions [columnData]="clientDetails" [tableAction]="false" [showDeleteDigitalPass]="showDeleteDigitalPass"
                        (changeEvent)="changeInAction($event)">
                    </prospect-list-actions>
                </div>
            </div>

            <!-- Info Icons Skeleton -->
            <div *ngIf="showSkeleton" class="px-3 flex mt-2">
                <div>
                    <p-skeleton styleClass="w-3rem h-2rem"></p-skeleton>
                </div>
                <div class="ml-1">
                    <p-skeleton styleClass="w-3rem h-2rem"></p-skeleton>
                </div>
                <div class="ml-1">
                    <p-skeleton styleClass="w-3rem h-2rem"></p-skeleton>
                </div>
                <div class="ml-1">
                    <p-skeleton styleClass="w-3rem h-2rem"></p-skeleton>
                </div>
                <div class="ml-1">
                    <p-skeleton styleClass="w-3rem h-2rem"></p-skeleton>
                </div>
                <div class="ml-1">
                    <p-skeleton styleClass="w-3rem h-2rem"></p-skeleton>
                </div>
            </div>
        </div>

        <!-- Client Details Wrapper -->
        <div class="hidden md:block">
            <client-profile-details-tab [clientDetails]="client" [showSkeleton]="showSkeleton$" [tenantId]="tenantId"></client-profile-details-tab>
        </div>
        <!-- Client Details Wrapper -->
    </div>

    <hr [ngClass]="isCurrentTenantClient ? 'border-300' : 'border-white'"
        class="md:hidden border-top-1 border-bottom-none border-left-none border-right-none my-0" />
<!-- </div> -->
<!-- Left Side -->

<!-- Send SMS Modal -->
<send-bulk-sms *ngIf="toggleCreateSmsDialog$ | async" [visible]="toggleCreateSmsDialog$.value"
    [tenantId]="currentTenantId" [SelectedClient]="SelectedClient" (hide)="closeCreateSmsDialog($event)">
</send-bulk-sms>
<!-- Send SMS Modal -->

<!-- Send Email Modal -->
<send-bulk-email *ngIf="toggleSendEmailDialog$ | async" [visible]="toggleSendEmailDialog$.value"
    [tenantId]="currentTenantId" [SelectedClient]="SelectedClient" (hide)="closeSendEmailDialog($event)">
</send-bulk-email>
<!-- Send Email Modal -->

<!-- Send WhatsApp Modal -->
<send-whatsapp *ngIf="toggleSendWhatsAppDialog$ | async" [visible]="toggleSendWhatsAppDialog$.value"
    [tenantId]="currentTenantId" [SelectedClient]="SelectedClient" (hide)="closeSendWhatsAppDialog($event)">
</send-whatsapp>
<!-- Send WhatsApp Modal -->

<book-appointment *ngIf="showBookAppointmentPopup" [visible]="showBookAppointmentPopup" [clientId]="client.id"
    [tenantId]="currentTenantId" (CloseBookAppointment)="CloseBookAppointment($event)">
 </book-appointment>
